<script lang="ts">
import DkOlMap from '@nuxtDatakodeUtils/components/dk-ol-map/dk-ol-map.vue'
import DkOlLayers from '@nuxtDatakodeUtils/components/dk-ol-map/layers/dk-ol-layers.vue'
import DkOlPrint from '@nuxtDatakodeUtils/components/dk-ol-map/controls/dk-ol-print.vue'
// import DkOlMeasure from '@nuxtDatakodeUtils/components/dk-ol-map/controls/dk-ol-measure.vue'
import DkOlLegend from '@nuxtDatakodeUtils/components/dk-ol-map/controls/dk-ol-legend.vue'
import DkOlGeosearch from '@nuxtDatakodeUtils/components/dk-ol-map/controls/dk-ol-geosearch.vue'
import DkOlPopup from '@nuxtDatakodeUtils/components/dk-ol-map/overlay/dk-ol-popup.vue'
import i3pSubComponent from '@nuxtDatakodeUtils/components/i3p/I3pSubComponent.vue'
import type { FeatureLike } from 'ol/Feature'
import { useTheme } from 'vuetify'
import DkOlFullscreen from '@nuxtDatakodeUtils/components/dk-ol-map/controls/dk-ol-fullscreen.vue'
import DkOlMeasure from '@nuxtDatakodeUtils/components/dk-ol-map/controls/dk-ol-measure.vue'
import MapTooltip from './map/map-tooltip.vue'
import CommandsLayer from '~/components/I3pComponent/Layer.vue'
import { CommandMapService } from '~/services/commandMap.service'
import { MajicEventEnum } from '~/enum/MajicEvent.enum'
import type { ApplicationService } from '~/services/application.service'

// noinspection JSUnusedGlobalSymbols
export default {
    name: 'CommandMapPanel',
    components: {
        DkOlMeasure,
        MapTooltip,
        DkOlPrint,
        DkOlLegend,
        DkOlMap,
        DkOlLayers,
        // DkOlScale,
        // DkOlMeasure,
        DkOlPrint,
        DkOlGeosearch,
        DkOlPopup,
        CommandsLayer,
        DkOlFullscreen,
    },
    extends: i3pSubComponent,
    data() {
        return {
            mapService: null as CommandMapService,
            popupFeature: null,
            popupContent: null as string,
            tooltipFeatures: [] as FeatureLike[],
        }
    },
    computed: {
        applicationService(): ApplicationService {
            return this.$applicationService as ApplicationService
        },
        editMode(): boolean {
            return this.i3pService.editMode
        },
        bbox(): { latitude_min: number, latitude_max: number, longitude_min: number, longitude_max: number } {
            return this.applicationService.getBBox()
        },
        // legend(): Legend {
        //     return this.$refs.legend.legend
        // },
        translationName(): string {
            return this.i3pService.currentEntity.translationKey
        },
        currentFeature(): FeatureLike {
            return this.$refs.commandsLayer?.currentFeature
        },
    },
    created() {
        this.theme = useTheme()
    },
    mounted(): void {
        if (this.$refs?.dkmap?.map)
            this.i3pService.setMap(this.$refs.dkmap.map as Map)
    },
    methods: {
        bboxFromCurrentFeature(): FeatureLike | null {
            if (this.currentFeature) {
                return this.currentFeature.getGeometry().getExtent()
            }
            return null
        },
        hoverFeatures(event: { features: FeatureLike[] }) {
            const features = event.features
            const properties = features[0]?.getProperties()
            if (properties)
                this.tooltipFeatures = features
            else
                this.tooltipFeatures = []
        },
        clickFeatures(event: { features: FeatureLike[] }) {
            const features = event.features
            const insee = features[0].get('insee')
            if (insee)
                this.i3pService.emitter.emit(MajicEventEnum.selectedCommune, { insee })
        },
        displayAll(): void {
            this.$refs.commandsLayer?.displayAll()
        },
        onLegendMounted({ legend }) {
            this.mapService = new CommandMapService((this.$refs.dkmap as DkOlMap)?.map)
            this.mapService.setLegend(legend)
        },
    },
}
</script>

<template>
    <div class="dk-ol-map mb-4 position-relative" :class="editMode ? 'has-hover' : ''">
        <DkOlMap ref="dkmap" :bbox>
            <DkOlLayers :layers="applicationService.getMapLayers()" />
            <CommandsLayer
                ref="commandsLayer"
                :map-service
                :i3p-service
                @hover-features="hoverFeatures($event)"
                @click-features="editMode && clickFeatures($event)"
            />

            <DkOlPopup ref="popup" :feature="popupFeature" :html="popupContent" />

            <DkOlFullscreen />
            <DkOlLegend ref="legend" @legend-mounted="onLegendMounted" />

            <ol-layerswitcher-control />
            <ol-scaleline-control bar />

            <!--            <ol-printdialog-control title="TEST" :pdf="false" lang="fr" /> -->

            <DkOlMeasure />

            <DkOlGeosearch
                :xmin="bbox.longitude_min"
                :ymin="bbox.latitude_min"
                :xmax="bbox.longitude_max"
                :ymax="bbox.latitude_max"
            />

            <DkOlPrint />
        </DkOlMap>
        <MapTooltip
            ref="mapTooltip"
            :features="tooltipFeatures" translation-name="commune"
        />
    </div>
</template>

<style>
.dk-ol-map {
    &.has-hover {
        cursor: pointer;
    }

    div.ol-legend {
        z-index: 15;
        min-width: 200px;
    }

    div.ol-legend > canvas.ol-legendImg {
        background: #fff;
    }

    .ol-scale-bar {
        margin-left: 40px;
    }

    .ol-layerswitcher {
        z-index: 10;
    }

    .ol-popup-content {
        max-width: 400px;
    }
}
</style>
